/* Use the app's existing selects so variant IDs, pricing and availability stay authoritative. */
(() => {
  const initialized = new WeakSet();
  function alignRollDisplayPrice(picker, price, material, size) {
    // Wallcoco's cart transform converts the USD option price at Shopify's
    // presentment rate. The catalog variant includes separate Markets pricing,
    // so its localized/base price ratio is not the rate for configured rolls.
    // Change display only: the app must keep sending its original shop price.
    const currency = window.Shopify?.currency;
    const rate = Number(currency?.rate);
    if (!currency?.active || !Number.isFinite(rate) || rate <= 0) return;
    let options;
    try {
      options = JSON.parse(picker.querySelector('[data-wallcoco-options]')?.textContent || 'null');
    } catch { return; }
    if (!Array.isArray(options)) return;
    const option = options.find(item => item.material === material && item.size === size);
    if (!option || !Number.isFinite(Number(option.price)) || Number(option.price) < 0) return;
    let formatter;
    try {
      formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency.active
      });
    } catch { return; }
    const format = amount => formatter.format(Math.round(Number(amount) * rate * 100) / 100);
    const formatted = format(option.price);
    const update = (node, value) => {
      if (node && node.textContent !== value) node.textContent = value;
    };
    price.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale')
      .forEach(node => update(node, formatted));
    update(picker.querySelector('[data-wc-price]'), formatted);
    picker.querySelectorAll('.wc-card').forEach(card => {
      const cardOption = options.find(item => item.material === material &&
        item.size === card.querySelector('.wc-card-size')?.textContent);
      if (cardOption && Number.isFinite(Number(cardOption.price))) {
        update(card.querySelector('.wc-card-price'), format(cardOption.price));
      }
    });
  }
  function openSampleDialog(picker, trigger) {
    const isMural = picker.matches('[data-mural-customizer]');
    const material = picker.querySelector('[data-wc-material]');
    const size = picker.querySelector('[data-wc-size]');
    const info = picker.closest('.product__info-container');
    const form = info?.querySelector('product-form form');
    let options;
    let pricing;
    try {
      if (isMural) {
        pricing = JSON.parse(picker.querySelector('[data-pricing-json]').textContent);
        let sizes = (pricing.sampleOptions || []).filter(item => item.id && item.label && Number(item.price) > 0);
        if (!sizes.length && Number(pricing.samplePrice) > 0) sizes = [{ id: 'legacy', label: pricing.sampleLabel || 'Sample', price: pricing.samplePrice }];
        if (pricing.sampleMaterialMode === 'kit') {
          const label = pricing.sampleKitLabel || 'Complete material sample kit';
          sizes = [{ id: '__sample_kit__', label, price: Number(pricing.sampleKitPrice) || sizes[0]?.price }];
          options = sizes.map(item => ({ material: label, materialId: '__sample_kit__', size: item.label, optionId: item.id, price: Number(item.price) / 100 }));
        } else {
          options = (pricing.materials || []).flatMap(item => sizes.map(sample => ({
            material: item.label, materialId: item.id, productionCode: item.productionCode,
            size: sample.label, optionId: sample.id, price: Number(sample.price) / 100
          })));
        }
      } else options = JSON.parse(picker.querySelector('[data-wallcoco-options]').textContent);
    } catch { return; }
    if (!Array.isArray(options) || (!isMural && (!material || !size || !form))) return;
    const samples = options.filter(option => (isMural || /sample/i.test(option.size)) && Number.isFinite(Number(option.price)) && Number(option.price) >= 0);
    if (!samples.length) return;
    const selectedMaterial = isMural ? picker.querySelector('.mural-cta__material.is-selected .mural-cta__material-name')?.textContent.trim() : material.value;
    let selected = samples.find(option => option.material === selectedMaterial) || samples[0];
    const materialSamples = samples.filter((option, index) => samples.findIndex(item => item.material === option.material) === index);
    const currency = window.Shopify?.currency;
    const rate = Number(currency?.rate);
    if (!currency?.active || !Number.isFinite(rate) || rate <= 0) return;
    const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: currency.active
    }).format(Math.round(Number(amount) * rate * 100) / 100);
    const dialog = document.createElement('dialog');
    dialog.className = 'z-sample-dialog';
    dialog.setAttribute('aria-labelledby', 'z-sample-title');
    dialog.innerHTML = `<button type="button" class="z-sample-close" aria-label="Close sample window">×</button>
      <header><p class="z-sample-eyebrow">TRY IT AT HOME</p><h2 id="z-sample-title">Order a sample</h2>
      <p>See the colour, print and finish in your own room.</p></header>
      <div class="z-sample-choices" role="group" aria-label="Sample material"></div>
      <div class="z-sample-details" aria-live="polite"><div><span>Sample size</span><strong class="z-sample-measurement"></strong></div><div><span>Price per sample</span><strong class="z-sample-price"></strong></div></div>
      <p class="z-sample-note">A sample shows part of the design and helps you check the colour and material before placing your full order.</p>
      <p class="z-sample-error" role="alert" hidden></p>
      <button type="button" class="z-sample-add"></button>
      <p class="z-sample-status" role="status"></p>`;
    const productImage = picker.closest('product-info')?.querySelector('.product__media img');
    const productTitle = info.querySelector('.product__title h1')?.textContent.trim();
    if (productImage && productTitle) {
      const preview = document.createElement('div');
      preview.className = 'z-sample-product';
      const thumbnail = document.createElement('img');
      thumbnail.src = productImage.currentSrc || productImage.src;
      thumbnail.alt = '';
      thumbnail.width = 42;
      thumbnail.height = 42;
      const name = document.createElement('span');
      name.textContent = productTitle;
      preview.append(thumbnail, name);
      dialog.querySelector('header').append(preview);
    }
    const choices = dialog.querySelector('.z-sample-choices');
    const add = dialog.querySelector('.z-sample-add');
    const error = dialog.querySelector('.z-sample-error');
    let busy = false;
    const close = () => { if (!busy) dialog.close(); };
    dialog.querySelector('.z-sample-close').addEventListener('click', close);
    dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
    });
    dialog.addEventListener('close', () => {
      dialog.remove();
      document.documentElement.classList.remove('z-sample-open');
      trigger.focus({ preventScroll: true });
    }, { once: true });
    function render() {
      choices.querySelectorAll('button').forEach((button, index) => button.setAttribute('aria-pressed', String(materialSamples[index].material === selected.material)));
      const match = selected.size.match(/(\d+(?:\.\d+)?)\s*["″]?\s*W\s*["″]?\s*[x×]\s*(\d+(?:\.\d+)?)\s*["″]?\s*H/i);
      const measurement = match ? `${match[1]} × ${match[2]} in (${Number((match[1] * 2.54).toFixed(1))} × ${Number((match[2] * 2.54).toFixed(1))} cm)` : selected.size;
      dialog.querySelector('.z-sample-measurement').textContent = measurement;
      dialog.querySelector('.z-sample-price').textContent = money(totalPrice());
      add.textContent = `Add sample to cart · ${money(totalPrice())}`;
    }
    materialSamples.forEach(option => {
      const button = document.createElement('button');
      button.type = 'button';
      const title = document.createElement('strong');
      title.textContent = option.material.replace(/\s+Wallpaper$/i, '');
      const detail = document.createElement('span');
      detail.textContent = /peel/i.test(option.material) ? 'Self-adhesive · no paste needed' : /textured/i.test(option.material) ? 'Textured finish · paste required' : selected.materialId === '__sample_kit__' ? 'Compare the available material finishes' : 'Smooth matte finish · paste required';
      button.append(title, detail);
      button.addEventListener('click', () => { if (!busy) { selected = samples.find(item => item.material === option.material && item.size === selected.size) || option; render(); } });
      choices.append(button);
    });
    const sizes = [...new Set(samples.map(option => option.size))];
    if (sizes.length > 1) {
      const label = document.createElement('label');
      label.className = 'z-sample-option';
      label.textContent = 'Sample size';
      const selectSize = document.createElement('select');
      sizes.forEach(value => { const option = document.createElement('option'); option.value = value; option.textContent = value; selectSize.append(option); });
      selectSize.value = selected.size;
      selectSize.addEventListener('change', () => {
        selected = samples.find(option => option.material === selected.material && option.size === selectSize.value) || selected;
        render();
      });
      label.append(selectSize);
      choices.after(label);
    }
    let customization;
    const customizationPrice = Number(pricing?.sampleColorCustomization?.price) / 100;
    if (pricing?.sampleMaterialMode !== 'kit' && pricing?.sampleColorCustomization?.enabled && Number.isFinite(customizationPrice) && customizationPrice >= 0) {
      const label = document.createElement('label');
      label.className = 'z-sample-option';
      customization = document.createElement('input');
      customization.type = 'checkbox';
      customization.addEventListener('change', render);
      label.append(customization, document.createTextNode(`${pricing.sampleColorCustomization.label || 'Color customization'} · +${money(customizationPrice)}`));
      dialog.querySelector('.z-sample-note').after(label);
    }
    let comment;
    if (isMural && picker.querySelector('[data-sample-comment-textarea]')) {
      const notes = document.createElement('details');
      notes.className = 'z-sample-notes';
      const summary = document.createElement('summary');
      summary.textContent = 'Add an order note (optional)';
      comment = document.createElement('textarea');
      comment.rows = 2;
      comment.setAttribute('aria-label', 'Sample order note');
      comment.placeholder = 'Any special notes for your sample?';
      notes.append(summary, comment);
      add.before(notes);
    }
    function totalPrice() { return Number(selected.price) + (customization?.checked ? customizationPrice : 0); }
    add.addEventListener('click', async () => {
      if (busy) return;
      busy = true;
      add.disabled = true;
      error.hidden = true;
      add.textContent = 'Adding sample…';
      const previousMaterial = material?.value;
      const previousSize = size?.value;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      let response;
      let restored = false;
      const restoreRoll = () => {
        if (restored || isMural) return;
        restored = true;
        material.value = previousMaterial;
        material.dispatchEvent(new Event('change', { bubbles: true }));
        size.value = previousSize;
        size.dispatchEvent(new Event('change', { bubbles: true }));
        enhanceRolls();
      };
      try {
        let request;
        if (isMural) {
          // Follow Wallcoco's sample contract; the server calculates the price.
          // No wall dimensions or configured mural selection are changed.
          const properties = {
            _mural_material: selected.materialId,
            _mural_sample: JSON.stringify({ optionId: selected.optionId, colorCustomization: !!customization?.checked }),
            _mural_fit: JSON.stringify({ mode: 'fill', sizeLabel: 'Size', materialLabel: 'Material', orderCommentLabel: 'Order Comment', cropUrlLabel: 'Crop preview', sampleCustomizationLabel: 'Sample Customization', sampleKitLabel: pricing.sampleKitLabel || 'Complete material sample kit', sampleKitPropertyLabel: 'Sample Kit' })
          };
          if (selected.materialId === '__sample_kit__') properties['Sample Kit'] = selected.material;
          else Object.assign(properties, { Size: selected.size, Material: selected.material, _mural_display_size: selected.size, _mural_display_material: selected.material, '_Material code': selected.productionCode || selected.material });
          if (customization?.checked) properties['Sample Customization'] = pricing.sampleColorCustomization.label || 'Color customization';
          if (comment?.value.trim()) { properties['Order Comment'] = comment.value.trim(); properties._mural_order_comment = comment.value.trim(); }
          const body = { items: [{ id: Number(picker.dataset.variantId), quantity: 1, properties }] };
          if (cart) {
            body.sections = cart.getSectionsToRender().map(section => section.id);
            body.sections_url = window.location.pathname;
            cart.setActiveElement(trigger);
          }
          request = fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: JSON.stringify(body) });
        } else {
          // Use the app's own selection and USD price properties; its cart
          // interceptor remains authoritative. Restore before the next paint.
          material.value = selected.material;
          material.dispatchEvent(new Event('change', { bubbles: true }));
          size.value = selected.size;
          size.dispatchEvent(new Event('change', { bubbles: true }));
          if (size.value !== selected.size || size.selectedOptions[0]?.disabled) throw new Error('This sample is unavailable. Please choose another material.');
          const body = new FormData(form);
          body.set('quantity', '1');
          if (cart) {
            body.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
            body.set('sections_url', window.location.pathname);
            cart.setActiveElement(trigger);
          }
          request = fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body });
        }
        restoreRoll();
        const result = await request;
        response = await result.json();
        if (!result.ok || response.status) throw new Error(response.description || 'Could not add the sample. Please try again.');
      } catch (failure) {
        error.textContent = failure.message || 'Could not add the sample. Please try again.';
        error.hidden = false;
      } finally {
        restoreRoll();
        busy = false;
        add.disabled = false;
        render();
      }
      if (!error.hidden) return;
      dialog.close();
      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sample-dialog', cartData: response });
      if (cart) { cart.classList.remove('is-empty'); cart.renderContents(response.items ? { ...response, ...response.items[0] } : response); }
      else window.location.assign(window.routes.cart_url);
    });
    render();
    document.body.append(dialog);
    document.documentElement.classList.add('z-sample-open');
    dialog.showModal();
  }
  function enhanceRolls() {
    document.querySelectorAll('[data-wallcoco-picker]').forEach(picker => {
      const select = picker.querySelector('[data-wc-material]');
      const size = picker.querySelector('[data-wc-size]');
      if (!select || !size || !select.options.length) return;
      select.setAttribute('aria-label', 'Choose material');
      size.setAttribute('aria-label', 'Choose roll size or sample');
      let cards = picker.querySelector('.z-roll-materials');
      if (!cards) {
        cards = document.createElement('div');
        cards.className = 'z-roll-materials';
        cards.setAttribute('role', 'group');
        cards.setAttribute('aria-label', 'Choose material');
        select.parentElement.after(cards);
      }
      const options = [...select.options].filter(option => option.value);
      if (cards.dataset.options !== JSON.stringify(options.map(option => option.value))) {
        cards.replaceChildren(...options.map(option => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'z-roll-material';
          button.textContent = option.textContent.replace(/\s+Wallpaper$/i, '');
          button.dataset.value = option.value;
          if (/non[ -]?woven/i.test(option.textContent)) {
            const badge = document.createElement('span');
            badge.className = 'z-roll-popular';
            badge.textContent = 'Most popular';
            button.append(badge);
          }
          button.addEventListener('click', () => {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            enhanceRolls();
          });
          return button;
        }));
        cards.dataset.options = JSON.stringify(options.map(option => option.value));
      }
      cards.querySelectorAll('button').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.value === select.value));
        button.disabled = options.find(option => option.value === button.dataset.value)?.disabled || false;
      });
      const labels = picker.querySelectorAll('.wc-label');
      ['Choose material', picker.querySelector('.z-roll-dimensions') ? 'Set roll height' : 'Choose roll size'].forEach((text, index) => {
        if (labels[index] && labels[index].textContent !== text) labels[index].textContent = text;
      });
      let description = picker.querySelector('.z-roll-description');
      if (!description) {
        description = document.createElement('p');
        description.className = 'z-roll-description';
        description.setAttribute('aria-live', 'polite');
        cards.after(description);
      }
      const materialName = select.selectedOptions[0]?.textContent || '';
      const materialHelp = /peel/i.test(materialName) ? 'Self-adhesive wallpaper. Apply to a clean, smooth surface.' : /textured/i.test(materialName) ? 'A textured finish. Wallpaper paste is required for installation.' : 'A smooth, matte finish. Wallpaper paste is required for installation.';
      if (description.textContent !== materialHelp) description.textContent = materialHelp;
      const sizeOptions = [...size.options].filter(option => option.value);
      const samples = sizeOptions.filter(option => /sample/i.test(option.textContent));
      const rolls = sizeOptions.filter(option => !/sample/i.test(option.textContent)).map(option => {
        const dimensions = option.textContent.match(/(\d+(?:\.\d+)?)\s*["″]?\s*W\s*["″]?\s*[x×]\s*(\d+(?:\.\d+)?)\s*["″]?\s*H/i);
        return { option, width: Number(dimensions?.[1]), height: Number(dimensions?.[2]) };
      });
      const fixedWidth = rolls.length > 0 && rolls.every(roll => roll.width === 20 && roll.height > 0);
      if (fixedWidth) {
        const imperial = ['US', 'CA', 'GB'].includes(picker.closest('product-info')?.dataset.country || 'US');
        if (!picker.dataset.rollDefault) {
          picker.dataset.rollDefault = 'true';
          if (samples.some(option => option.value === size.value)) {
            size.value = rolls.find(roll => !roll.option.disabled)?.option.value || size.value;
            size.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        if (labels[1] && labels[1].textContent !== 'Set roll height') labels[1].textContent = 'Set roll height';
        let dimensions = picker.querySelector('.z-roll-dimensions');
        if (!dimensions) {
          dimensions = document.createElement('div');
          dimensions.className = 'z-roll-dimensions';
          dimensions.innerHTML = '<div><span class="z-dimension-label">Roll width</span><div class="z-fixed-width"><strong>20 in</strong><span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 10V7a5 5 0 0 1 10 0v3M6 10h12v11H6z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg> Fixed</span></div><span class="z-dimension-equivalent">50.8 cm</span></div><label><span class="z-dimension-label">Roll height</span><select class="z-roll-height" aria-label="Roll height"></select></label>';
          size.parentElement.before(dimensions);
          dimensions.querySelector('select').addEventListener('change', event => {
            picker.dataset.lastRoll = event.target.value;
            size.value = event.target.value;
            size.dispatchEvent(new Event('change', { bubbles: true }));
            enhanceRolls();
          });
        }
        const height = dimensions.querySelector('select');
        const widthLabel = dimensions.querySelector('.z-fixed-width strong');
        const equivalent = dimensions.querySelector('.z-dimension-equivalent');
        const primaryWidth = imperial ? '20 in' : '50.8 cm';
        const secondaryWidth = imperial ? '50.8 cm' : '20 in';
        if (widthLabel.textContent !== primaryWidth) widthLabel.textContent = primaryWidth;
        if (equivalent.textContent !== secondaryWidth) equivalent.textContent = secondaryWidth;
        const signature = JSON.stringify([imperial, rolls.map(roll => [roll.option.value, roll.option.disabled])]);
        if (height.dataset.options !== signature) {
          height.replaceChildren(...rolls.map(roll => {
            const option = document.createElement('option');
            option.value = roll.option.value;
            const centimetres = Number((roll.height * 2.54).toFixed(1));
            option.textContent = imperial ? `${roll.height} in (${centimetres} cm)` : `${centimetres} cm (${roll.height} in)`;
            option.disabled = roll.option.disabled;
            return option;
          }));
          height.dataset.options = signature;
        }
        const isSample = samples.some(option => option.value === size.value);
        if (!isSample) picker.dataset.lastRoll = size.value;
        height.value = isSample ? (picker.dataset.lastRoll || rolls[0].option.value) : size.value;
        height.disabled = isSample;
        dimensions.classList.toggle('is-sample', isSample);
        size.parentElement.classList.add('z-roll-native');
        size.setAttribute('aria-hidden', 'true');
        size.tabIndex = -1;
      }
      const info = picker.closest('.product__info-container');
      const price = info?.querySelector('[id^="price-"]');
      let order = info?.querySelector('.z-roll-order');
      if (fixedWidth && info && price && !order) {
        order = document.createElement('div');
        order.className = 'z-roll-order';
        picker.closest('.shopify-app-block').after(order);
        order.append(price);
        const actions = document.createElement('div');
        actions.className = 'z-roll-actions';
        const quantity = info.querySelector('.product-form__quantity');
        const form = info.querySelector('product-form');
        const buy = form?.parentElement;
        if (quantity && buy) {
          actions.append(quantity, buy);
          order.append(actions);
        }
        const tax = info.querySelector('.product__tax');
        if (tax) order.append(tax);
      }
      if (fixedWidth && order && samples.length) {
        let sampleButton = order.querySelector('.z-roll-sample-toggle');
        if (!sampleButton) {
          sampleButton = document.createElement('button');
          sampleButton.type = 'button';
          sampleButton.className = 'z-roll-sample-toggle';
          sampleButton.addEventListener('click', () => openSampleDialog(picker, sampleButton));
          order.append(sampleButton);
        }
        const isSample = samples.some(option => option.value === size.value);
        if (sampleButton.dataset.mode !== String(isSample)) {
          sampleButton.innerHTML = '<span class="z-sample-invite-icon" aria-hidden="true"><svg viewBox="0 0 32 32" fill="none"><path d="m7 10 11-5 8 4v17l-11 4-8-4V10Z"/><path d="m7 10 8 4 11-5M15 14v16M3 5l5-2M3 11V5"/></svg></span><span class="z-sample-invite-copy"><span class="z-sample-invite-kicker">TRY IT AT HOME</span><strong>Start with a sample</strong><small>See the colour. Feel the finish. Choose with confidence.</small></span><span class="z-sample-invite-action">Order a sample <span aria-hidden="true">→</span></span>';
          sampleButton.setAttribute('aria-label', 'Order a sample');
          sampleButton.setAttribute('aria-haspopup', 'dialog');
          sampleButton.dataset.mode = String(isSample);
        }
        sampleButton.disabled = !isSample && samples[0].disabled;
      }
      const reassurance = info?.querySelector('.z-purchase-reassurance');
      if (order && reassurance && reassurance.parentElement !== order) order.append(reassurance);
      if (price && !price.querySelector('.z-purchase-heading')) {
        const heading = document.createElement('h2');
        heading.className = 'z-purchase-heading';
        heading.textContent = 'Price per roll';
        price.prepend(heading);
      }
      if (price) {
        alignRollDisplayPrice(picker, price, select.value, size.value);
        const priceHeading = price.querySelector('.z-purchase-heading');
        const priceLabel = /sample/i.test(size.selectedOptions[0]?.textContent || '') ? 'Sample price' : 'Price per roll';
        if (priceHeading.textContent !== priceLabel) priceHeading.textContent = priceLabel;
        let summary = price.querySelector('.z-roll-selection');
        if (!summary) {
          summary = document.createElement('p');
          summary.className = 'z-roll-selection';
          price.append(summary);
        }
        const summaryText = materialName + ' · ' + (size.selectedOptions[0]?.textContent || '');
        if (summary.textContent !== summaryText) summary.textContent = summaryText;
      }
      select.parentElement.classList.add('z-roll-native');
      select.tabIndex = -1;
      if (!picker.querySelector('.z-roll-help')) {
        const help = document.createElement('p');
        help.className = 'z-roll-help';
        size.parentElement.after(help);
      }
      const help = picker.querySelector('.z-roll-help');
      const helpText = /sample/i.test(size.selectedOptions[0]?.textContent || '') ? 'Sample selected. Review its size and price below.' : fixedWidth ? 'Select a height to update your roll price.' : 'Choose your roll size. The price updates with your selection.';
      if (help.textContent !== helpText) help.textContent = helpText;
      if (!initialized.has(picker)) {
        initialized.add(picker);
        const materialChanges = new WeakMap();
        // Capture before Wallcoco rebuilds sizes and defaults to its first sample.
        // Both the native select and the material buttons use this same path.
        picker.addEventListener('change', event => {
          if (event.target.matches('[data-wc-material]')) {
            const current = picker.querySelector('[data-wc-size]');
            materialChanges.set(event, {
              value: current?.value,
              sample: /sample/i.test(current?.selectedOptions[0]?.textContent || '')
            });
          }
        }, true);
        picker.addEventListener('change', event => {
          const previous = materialChanges.get(event);
          const current = picker.querySelector('[data-wc-size]');
          if (previous?.value && current) {
            const available = [...current.options].filter(option => option.value && !option.disabled);
            const match = available.find(option => option.value === previous.value) ||
              available.find(option => /sample/i.test(option.textContent) === previous.sample);
            if (match) {
              current.value = match.value;
              // Update the app's price and cart properties before another click.
              current.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          requestAnimationFrame(enhanceRolls);
        });
      }
    });
  }
  function initializeDetails() {
    document.querySelectorAll('[data-product-details]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const tabs = [...section.querySelectorAll('[role="tab"]')];
      const panels = [...section.querySelectorAll('[data-detail-panel]')];
      function activate(index, focus = false) {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      }
      panels.forEach((panel, i) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabs[i].id);
        panel.tabIndex = 0;
      });
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          activate(next, true);
        });
      });
      activate(0);
      section.querySelector('[role="tablist"]').hidden = false;
    });
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-mural-sample]');
    if (!trigger) return;
    const app = trigger.closest('[data-mural-customizer]');
    if (!app) return;
    openSampleDialog(app, trigger);
    if (document.querySelector('.z-sample-dialog[open]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  function start() {
    initializeDetails();
    document.querySelectorAll('[data-open-product-sample]').forEach(link => {
      if (link.dataset.sampleReady) return;
      link.dataset.sampleReady = 'true';
      link.addEventListener('click', event => {
        const picker = document.querySelector('[data-wallcoco-picker], [data-mural-customizer]');
        if (!picker) return;
        event.preventDefault();
        openSampleDialog(picker, link);
      });
    });
    const product = document.querySelector('product-info');
    if (!product) return;
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; enhanceRolls(); });
    }).observe(product, { childList: true, subtree: true });
    enhanceRolls();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
